(function () {
  if (window.PWWCart && window.PWWCart.addItem) return;

  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function buildFormData(items) {
    const formData = new FormData();

    if (items.length === 1 && !items[0].properties) {
      formData.append("id", items[0].id);
      formData.append("quantity", items[0].quantity || 1);
      return formData;
    }

    items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity || 1);
      if (item.properties) {
        Object.entries(item.properties).forEach(([key, value]) => {
          formData.append(`items[${index}][properties][${key}]`, value);
        });
      }
    });

    return formData;
  }

  async function addItems(items, options) {
    const opts = options || {};
    const cartDrawer = getCartDrawer();
    const formData = buildFormData(items);

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      const sections = cartDrawer
        .getSectionsToRender()
        .map((section) => section.id);
      formData.append("sections", sections);
      formData.append("sections_url", window.location.pathname);
      if (typeof cartDrawer.setActiveElement === "function") {
        cartDrawer.setActiveElement(opts.button || document.activeElement);
      }
    }

    const cartAddUrl =
      (window.routes && window.routes.cart_add_url) || "/cart/add";
    const cartUrl = (window.routes && window.routes.cart_url) || "/cart";

    const response = await fetch(cartAddUrl, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      const message = data.description || data.message || "Error adding to cart";
      throw new Error(message);
    }

    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(data);
      if (cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.remove("is-empty");
      }
    } else {
      window.location.href = cartUrl;
    }

    return data;
  }

  function addItem(options) {
    const opts = options || {};
    if (!opts.variantId) return Promise.reject(new Error("Missing variantId"));
    return addItems(
      [{ id: opts.variantId, quantity: opts.quantity || 1 }],
      options
    );
  }

  function refreshCartDrawer() {
    const cartDrawer = getCartDrawer();
    const cartUrl = (window.routes && window.routes.cart_url) || "/cart";
    if (!cartDrawer) return Promise.resolve();

    return fetch(`${cartUrl}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceDrawer = html.querySelector("#CartDrawer");
        const targetDrawer = cartDrawer.querySelector("#CartDrawer");
        if (sourceDrawer && targetDrawer) {
          targetDrawer.innerHTML = sourceDrawer.innerHTML;
        }

        const sourceUpsellWrapper = html.querySelector(
          "#cart-drawer-upsell-wrapper"
        );
        const targetUpsellWrapper = document.querySelector(
          "#cart-drawer-upsell-wrapper"
        );
        if (sourceUpsellWrapper && targetUpsellWrapper) {
          targetUpsellWrapper.replaceWith(sourceUpsellWrapper);
        }

        const parsedStateElement = html.querySelector(
          "[data-cart-drawer-state]"
        );
        const parsedState = parsedStateElement
          ? JSON.parse(parsedStateElement.textContent)
          : null;
        const cartDrawerItems = cartDrawer.querySelector("cart-drawer-items");
        if (cartDrawerItems && typeof cartDrawerItems.updateCartUpsellToggleState === "function") {
          cartDrawerItems.updateCartUpsellToggleState();
        }
        if (
          parsedState &&
          cartDrawerItems &&
          typeof cartDrawerItems.updateCartUpsellVisibility === "function"
        ) {
          cartDrawerItems.updateCartUpsellVisibility(parsedState.item_count);
        }

        const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
        if (overlay) {
          overlay.addEventListener("click", cartDrawer.close.bind(cartDrawer));
        }
      })
      .catch((error) => {
        console.error("Error refreshing cart drawer:", error);
      });
  }

  function bindCartIcon() {
    const cartDrawer = getCartDrawer();
    const cartIcon = document.querySelector("#cart-icon-bubble");
    if (!cartDrawer || !cartIcon) return;
    if (cartIcon.dataset.pwwCartBound === "true") return;

    cartIcon.dataset.pwwCartBound = "true";
    cartIcon.addEventListener("click", (event) => {
      event.preventDefault();
      refreshCartDrawer().finally(() => {
        if (typeof cartDrawer.open === "function") {
          cartDrawer.open(cartIcon);
        }
      });
    });
  }

  function patchCartDrawerOpen() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;
    if (cartDrawer.dataset.pwwOpenPatched === "true") return;

    const originalOpen = cartDrawer.open && cartDrawer.open.bind(cartDrawer);
    if (!originalOpen) return;

    cartDrawer.open = function (triggeredBy) {
      refreshCartDrawer().finally(() => {
        originalOpen(triggeredBy);
      });
    };

    cartDrawer.dataset.pwwOpenPatched = "true";
  }

  window.PWWCart = {
    addItem,
    addItems,
    refreshCartDrawer,
  };

  window.addToCartPWW = function (variantId, quantity) {
    return addItem({ variantId: variantId, quantity: quantity || 1 });
  };

  document.addEventListener("DOMContentLoaded", () => {
    bindCartIcon();
    patchCartDrawerOpen();
    refreshCartDrawer();
  });
  document.addEventListener("shopify:section:load", () => {
    bindCartIcon();
    patchCartDrawerOpen();
  });
})();
